module.exports = __webpack_public_path__ + "2fb0d4878d6c59afc93f0897b233134e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Tutors/images/img_tutor_cloud.svg
// module id = 1609
// module chunks = 8